export { default as useGetProductsMap } from './useGetProductsMap';
